import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../common/http/fetch-get';
import { getSFCCRequestHeaders } from '../../sfcc/utilities/get-sfcc-request-headers';
import { getPricingApiConfig } from './config/actions';
export var fetchCustomerInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, baseUrl, isSFCCPricingOn, customerId, requestOptions, extensionQuery;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getPricingApiConfig(), baseUrl = _a.baseUrl, isSFCCPricingOn = _a.isSFCCPricingOn;
                if (!isSFCCPricingOn) {
                    return [2 /*return*/, null];
                }
                customerId = localStorage.getItem("customer-auth-id" /* CustomerAuthId */)
                    || localStorage.getItem("customer-guest-id" /* CustomerGuestId */);
                return [4 /*yield*/, getSFCCRequestHeaders()];
            case 1:
                requestOptions = _b.sent();
                extensionQuery = 'checkIfIsEPPCustomer=true';
                return [4 /*yield*/, fetchGet(baseUrl + "/customers/" + customerId + "?" + extensionQuery, requestOptions)];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}); };
